import type { ReactZoomPanPinchContext } from "react-zoom-pan-pinch";

import { animate, handleCancelAnimation } from "./animation";
import { calculateZoomToNodes } from "./calculateZoomToNodes";

//! This hooks is hack for zoom to multiple elements in the react-zoom-pan-pinch library because the library does not support zooming to multiple elements at once

const zoomToElements = (
  contextInstance: ReactZoomPanPinchContext,
  nodes: (HTMLElement | string)[],
  scale?: number,
  animationTime = 600,
): void => {
  handleCancelAnimation(contextInstance);

  const { wrapperComponent } = contextInstance;

  const targets: HTMLElement[] = nodes.flatMap(node => {
    if (typeof node !== "string") return [node];
    const element = document.getElementById(node);
    return element ? [element] : [];
  });

  if (wrapperComponent && targets.length && targets.every(target => wrapperComponent.contains(target))) {
    const targetState = calculateZoomToNodes(contextInstance, targets, scale);

    animate(contextInstance, targetState, animationTime);
  }
};

export { zoomToElements };
